export default __webpack_public_path__ + "static/media/code.afef39b5.png";